import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../../config/api';
import { formatDistanceToNow } from 'date-fns';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import './HomePage.css';

const getShortDescription = (text, maxLength) => {
  if (!text) return '';
  const plainText = text.replace(/(<([^>]+)>)/gi, '');
  if (plainText.length <= maxLength) {
    return plainText;
  }
  return plainText.substring(0, maxLength) + '...';
};

const getShortTitle = (text, maxLength) => {
  if (!text) return '';
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};

export const BlogHome = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBlogs = async () => {
    try {
      const res = await ApiService.get('blogs/list');
      if (!res.data.error) {
        setBlogs(res.data.meta);
      }
    } catch (err) {
      console.error('Error fetching blogs:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  return (

    <div className="container" style={{ maxWidth: "1250px", width: "100%" }}>
      {!loading && blogs.length === 0 ? null : (
        <>
          <h3 className="mb-2 text-color mt-5 mb-2">Invest / Buy Guide</h3>
          <div className="row">
            {loading
              ? Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="col-12 col-md-4 mb-4">
                  <div className="card blog-card border-0 shadow-sm h-100">
                    <Skeleton height={200} />
                    <div className="card-body">
                      <h5 className="card-title">
                        <Skeleton width="80%" />
                      </h5>
                      <p className="card-text text-muted">
                        <Skeleton count={3} />
                      </p>
                      <div className="d-flex justify-content-between align-items-center mt-2">
                        <Skeleton width={100} />
                        <Skeleton width={60} />
                      </div>
                    </div>
                  </div>
                </div>
              ))
              : blogs.slice(0, 3).map((blog) => (
                <div key={blog.id} className="col-12 col-md-4 mb-4">
                  <div className="card blog-card border-0 shadow-sm h-100">
                    <img
                      src={blog.image}
                      alt={blog.title}
                      className="card-img-top blog-card-img"
                    />
                    <div className="card-body">
                      <h5 className="card-title">
                        {getShortTitle(blog?.title, 70)}
                      </h5>
                      <p className="card-text text-muted">
                        {getShortDescription(blog?.description, 150)}
                      </p>
                      <div className="d-flex justify-content-between align-items-center mt-2">
                        <small style={{ color: 'gray' }}>
                          {formatDistanceToNow(new Date(blog?.createdAt), {
                            addSuffix: true,
                          })}
                        </small>
                        <span
                          style={{
                            color: 'var(--bs-primary)',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                          }}
                          onClick={() => navigate(`/blogs/${blog.slug}`)}
                        >
                          See More
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

          </div>

          <div className="d-flex justify-content-end">
            {loading ? (
              <Skeleton width={100} height={40} />
            ) : (
              <button
                className="btn-outline px-3 rounded-2 bg-transparent"
                style={{
                  color: "var(--bs-accent)",
                  border: "2px solid var(--bs-accent)",
                }}
                onClick={() => navigate("/blogs")}
              >
                See more
              </button>
            )}
          </div>
        </>
      )}
    </div>

  );
};
